import React from 'react'
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom'
import TimeSlotsRoutes from './Constants/routes'

const TimeSlots = () => {
  const match = useRouteMatch()
  return (
    <>
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/all`} />
        {TimeSlotsRoutes.map(({ path, Component, id, exact }) => (
          <Route
            path={`${match.url}${path}`}
            component={Component}
            exact={exact}
            key={id}
          />
        ))}
        <Redirect to="/dashboard/time-slots" />
      </Switch>
    </>
  );
}

export default TimeSlots